export interface ICreatePatientForm {
  documentTypeId: string;
  documentNumber: string;
  firstName: string;
  lastName: string;
  businessName: string;
  provinceId: string;
  cityId: string;
  address: string;
  email: string;
  isDataPolicyAccepted: boolean;
}

export const initialForm: ICreatePatientForm = {
  documentTypeId: "",
  documentNumber: "",
  firstName: "",
  lastName: "",
  businessName: "",
  provinceId: "",
  cityId: "",
  address: "",
  email: "",
  isDataPolicyAccepted: false
};
